import { en } from "./en";
import { pt } from "./pt";
import { es } from "./es";

export type Translations = typeof en;
export type Lang = "en" | "pt" | "es";

export const LANGS: Lang[] = ["en", "pt", "es"];

export const LANG_LABELS: Record<Lang, string> = {
  en: "EN",
  pt: "PT",
  es: "ES",
};

export const translations: Record<Lang, Translations> = { en, pt, es };
